import { ENDPOINTS } from '@/config/endpoints.js';

export async function fetchTeams(client) {
  return client.get(ENDPOINTS.TEAMS).json();
}

/**
 * Backend returns `{uuid, name, members}` flat — normalize to
 * `{team: {uuid, name}, members}` so callers can destructure cleanly.
 */
export async function fetchTeam(uuid, client) {
  const raw = await client.get(`${ENDPOINTS.TEAMS}/${uuid}`).json();
  return {
    team: { uuid: raw.uuid, name: raw.name, github_org: raw.github_org },
    members: Array.isArray(raw.members) ? raw.members : [],
  };
}

export async function createTeam({ name, githubOrg, githubOrgId }, client) {
  return client
    .post(ENDPOINTS.TEAMS, {
      json: { name, github_org: githubOrg, github_org_id: githubOrgId },
    })
    .json();
}

export async function deleteTeam(uuid, client) {
  return client.delete(`${ENDPOINTS.TEAMS}/${uuid}`).json();
}

/**
 * Backend returns the user fields flat (`{uuid, username, avatar_url}`);
 * wrap in `{user: ...}` so callers can write `const {user} = await ...`.
 * On 404 ky throws with the backend message surfaced via beforeError.
 */
export async function lookupGithubUser({ username }, client) {
  const raw = await client.post(`${ENDPOINTS.TEAMS}/lookup`, { json: { username } }).json();
  return { user: raw };
}

export async function addTeamMember({ teamUuid, userUuid, permission = 'viewer' }, client) {
  return client
    .post(`${ENDPOINTS.TEAMS}/${teamUuid}/members`, {
      json: { user_uuid: userUuid, permission },
    })
    .json();
}

export async function removeTeamMember({ teamUuid, memberUuid }, client) {
  return client.delete(`${ENDPOINTS.TEAMS}/${teamUuid}/members/${memberUuid}`).json();
}
